import { render, staticRenderFns } from "./procuring_entity.vue?vue&type=template&id=a004a120"
import script from "./procuring_entity.vue?vue&type=script&lang=js"
export * from "./procuring_entity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports